<template>
    <div class="requests-info">
            <div class="section-title">Verification of Service</div>
            <div class="past-due">
                <div class="text">
                    VOS forms must be submitted within 24 hours of assignment completion.
                </div>
                <div class="vos-options">
                    <div v-show="jobType == 1" class="field">
                        <div v-if="timeNotAllowed" class="signature-support" style="padding-bottom: 5px;">
                            <span class="is-danger">
                                Sorry, you cannot upload this VOS yet because the job date and time have yet to start.
                            </span>
                        </div>
                        <div class="control">
                            <div class="columns">
                                <div class="column is-3">
                                    <file-uploader :vuexStore="fileUploadStore" :vuexUploadAction="fileUploadAction" :buttonName="buttonName" :vuexSelectAction="fileSelectAction" :setDescription="setDescription"></file-uploader>
                                </div>
                                <div class="column is-9 pull-left">
                                    <p>Images or scanned</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="field">
                        <div class="control">
                            <div class="columns">
                                <div class="column is-3">
                                    <div class='formfield'>
                                        <button class="upload-button" @click="showDigital">+ Digital</button>
                                    </div>
                                </div>
                                <div class="column is-9 pull-left">
                                    <p>Digital signature</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div v-if="false" class="submitted">
                <div class="text">
                    Thank you for submitting your completed VOS.
                </div>
            </div>

            <div class="details gray-bg">
                <div v-show="true" class="files">
                    <div class="field file-padded-bottom-border">
                        <div class="control">
                            <div class="columns">
                                <div class="column is-8">
                                    <div class='formfield file-header'>
                                        File
                                    </div>
                                </div>
                                <div class="column is-4">
                                    <div class='formfield file-header file-header-date'>
                                        Date Created
                                    </div>
                                </div>
                            </div>
                        </div>
                        <cliploader :loading="showUploadLoader" :size="size" class="upload-file"></cliploader>
                    </div>
                    <div v-for="(file, index) in files" :key="file.id" class="field file-padded-top">
                        <div class="control" v-if="!file.show_client">
                            <div class="columns">
                                <div class="column is-8">
                                    <div class='formfield view-file' @click="showFile(file)" v-html="file.filename">
                                    </div>
                                </div>
                                <div class="column is-4">
                                    <div class='formfield'>
                                        <div class="uploaded-at pull-left">{{ formatDateTime(file.created_at) }}</div>
                                        <i @click.prevent="setDelete(file.id)" class="fa fa-trash-alt file-delete" aria-hidden="true"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!--<div class="vos-options">
                <div style="margin-bottom: 25px;">
                    <ul class="center-button">
                        <li>
                            <span v-on:click="submit('Yes')" class='button is-small is-link'>Submit</span>
                        </li>
                    </ul>
                </div>
            </div> -->
        </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import moment from 'moment'

export default {
    name: 'vos',
    data () {
        return {
            size: '50px',
            fileUploadStore: 'requestVos',
            fileSelectAction: 'canUploadFile',
            fileUploadAction: 'uploadFile',
            setDescription: false,
            buttonName: '+ Upload',
        }
    },

    computed: {
        ...mapState('requestVos', {
            files: state => state.files, // completed vos files
            timeNotAllowed: state => state.timeNotAllowed,
        }),

        ...mapState('requests', {
            formData: state => state.formData, // completed vos files
        }),

        ...mapGetters('requestVos', {
            showUploadLoader: 'getshowUploadLoader',
        }),

        ...mapGetters('requests', {
            jobType: 'getJobType',
            //formData: 'getFormData',
        }),

        ...mapGetters('nav', {
            activeInfoDisplay: 'getActiveInfoDisplay'
        }),
    },

    methods: {
        setDelete(id){
            // show modal to confirm deletion
            VueStore.dispatch('notify/setShowMessage', {key: 'showDeleteVosConfirm', bool: true});

            // setup vuex to so we can pull the selected id to delete
            // after user confirm
            VueStore.dispatch('requestVos/pushToFileDelete', id);
        },
        showImage(url){
            var iframe = '<html><head><style>body, html {width: 100%; height: 100%; margin: 0; padding: 0}</style></head><body><iframe src="'+url+'" style="height:calc(100% - 4px);width:calc(100% - 4px);"></iframe></html></body>';

            var win = window.open("","","width=600,height=480,toolbar=no,menubar=no,resizable=yes,top=200");
            win.document.write(iframe);

        //    var windowFeatures = "menubar=no,location=no,resizable=yes,scrollbars=yes,status=yes,width=800,height=600,top=100";

        //    window.open(url,'window',windowFeatures);
        },
        showFile(file){
            VueStore.dispatch('requestVos/setVariable', {key: 'selectedFile', value: file});
            VueStore.dispatch('notify/setShowMessage', {key: 'viewUploadedVosModal', bool: true});
        },
        showDigital(file){
            VueStore.dispatch('requestVos/setVariable', {key: 'selectedFile', value: file});
            VueStore.dispatch('notify/setShowMessage', {key: 'viewDigitalVosModal', bool: true});
        },

        // format datetime to 12/01/2018 at 4:00 PM
        formatDateTime: function(value) {
            if(!value) return 'Unknown'
            return moment(value).format('MM/DD/YY') + ' at ' + moment(value).format('hh:mm A');
        }
    },

    mounted(){

    },

    created(){

    }

}
</script>

<style scoped>
.upload-file{
    top: 20% !important;
    left: 50% !important;
}

.text {
    margin-bottom: 10px;
}

.vos-options {
    margin-top: 20px;
    margin-bottom: 30px;
}

span.is-danger{
    color: red;
}

</style>
